import React from 'react';
import { Spinner } from "@heroui/react";

interface LoadingProps {
  fullPage?: boolean;
  className?: string;
}

export const Loading: React.FC<LoadingProps> = ({ fullPage = false, className = '' }) => {
  const spinner = (
    <Spinner
      className={`text-[#172e50] ${className}`.trim()}
      size="lg"
      color="current"
      classNames={{
        circle1: 'border-b-[#172e50]',
        circle2: 'border-b-[#172e50]',
        dots: 'bg-[#172e50]',
        spinnerBars: 'bg-[#172e50]',
      }}
    />
  );

  if (fullPage) {
    return (
      <div className="flex items-center justify-center min-h-[calc(100vh-4rem)]">
        {spinner}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-12">
      {spinner}
    </div>
  );
};
